import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { List, ListItem, ListItemButton } from '@mui/material';

const StyledSidebar = styled(List)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 100%;
  max-width: fit-content;
  color: ${({ theme }) => theme.palette.text.primary};

  .MuiListItemButton-root {
    &:hover {
      background-color: ${({ theme }) => theme.palette.primary[5]};
    }
  }

  .Mui-selected {
    background-color: ${({ theme }) => theme.palette.primary[5]};
    font-weight: 600;
    font-size: 14px;
  }

`;

const StyledSidebarBtn = styled(ListItemButton)`
    padding: 4px;
    padding-right: 32px;
    border-radius: 4px;
    min-width: 100px;
    font-weight: 400;
    font-size: 1.4rem;
`;

export const Sidebar = ({
  items = [],
  onSelect = () => {},
  ...props
}) => (
  <StyledSidebar {...props}>
    {items.map((item, ind) => (
      <ListItem key={item.id} disablePadding onClick={() => onSelect(ind)}>
        <StyledSidebarBtn disableRipple selected={item.selected}>
          {item.value}
        </StyledSidebarBtn>
      </ListItem>
    ))}
  </StyledSidebar>
);

Sidebar.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
    selected: PropTypes.bool,
  })),
  onSelect: PropTypes.func,
};
